<template>
  <div>
    <Header>
      勤怠変更申請完了
    </Header>
    <div class="withholding-finished">
      <div class="px-3 pb-5">
        <div class="caution">
          <ul class="text-size-16">
            <li>
              給与は申請が事業所に承認されたタイミングでウォレットに反映されます
            </li>
            <li>
              数日経っても承認されない場合は事業所にチャットメッセージで連絡してください
            </li>
          </ul>
        </div>
        <div class="text-center">
          <div class="summary-area">
            <Balloon />
          </div>
          <p class="my-4 text-weight-500" data-testid="message">
            勤怠変更申請が完了しました！
          </p>
        </div>
        <AppButtonOutline
          :to="{ name: 'ApplicationsList' }"
          :block="true"
          class="d-block"
        >
          仕事管理に戻る
        </AppButtonOutline>
        <RecentOrdersWithRecommendText
          class="mt-4"
          :currentOrder="order"
          :orders="orders"
          :applicableOrderCount="applicableOrderCount"
        />
      </div>
    </div>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import Header from "@/components/organisms/common/Header.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import RecentOrdersWithRecommendText from "@/components/organisms/orders/RecentOrdersWithRecommendText.vue";
import { Application } from "@/types/order/Application";
import { Order } from "@/types/order/Order";
import { applicationService } from "@/app/services/ApplicationService";
import { orderService } from "@/app/services/OrderService";
import { authStore } from "@/store/auth";
import { showErrorModal } from "@/utils/showErrorModal";

@Component({
  components: {
    Header,
    AppButtonOutline,
    BlockBack,
    RecentOrdersWithRecommendText
  }
})
export default class AttendanceCorrectionFinished extends Vue {
  application: Application | null = null;

  orders: Order[] = [];
  applicableOrderCount = 0;

  get applicationId(): number {
    return Number(this.$route.params.applicationId);
  }

  get order() {
    return this.application?.order;
  }

  async created() {
    this.$loading.show();
    try {
      await this.fetchApplication();
      await this.fetchEachDayOrders();
    } catch (error) {
      showErrorModal(this, error as Error);
    } finally {
      this.$loading.hide();
    }
  }

  async fetchApplication() {
    this.application = await applicationService.fetchApplication(
      this.applicationId
    );
  }

  async fetchEachDayOrders() {
    if (!this.order) return;
    const { results, count } = await orderService.fetchOrdersEachDayWithCount({
      office: this.order.office.id,
      serviceName: authStore.workerService.serviceName,
      onlyHiring: true
    });
    this.orders = results;
    this.applicableOrderCount = count;
  }
}
</script>

<style lang="scss" scoped>
.summary-area {
  padding: 40px 0 20px;
}

.caution {
  padding: 16px;
  margin-top: 40px;
  font-size: 14px;
  background-color: $primary-bg;
  border: 1px solid $yellow;
  border-radius: 4px;

  ul {
    li {
      position: relative;
      padding-left: 20px;

      &::before {
        position: absolute;
        left: 0;
        content: "・";
      }

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
